import React, { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

// Scroll reveal that is self-healing: if the in-view observer never fires
// (e.g. section already on screen or observer blocked), a fallback timer
// forces the content visible so nothing can ever stay hidden.
export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div", ...rest }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setFallback(true), 900);
    return () => clearTimeout(t);
  }, []);

  const visible = inView || fallback;
  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.7, ease, delay: inView ? delay : 0 }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Masked line-by-line headline reveal
export const MaskedLines = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.16em] -mb-[0.12em]">
        <motion.span
          className="block leading-[1.06]"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export default Reveal;
